import { MappingTaxRate } from 'store/returns/models/mappingTaxRate';
import { Section } from 'store/returns/models/returnData';
import {
  deriveOssCountryIdsFromJsonMapping,
  getMappedSubsectionCodesFromJsonMapping,
  isOssReturnType,
  ossCountryHasMappedSubsection,
} from 'utils/oss-mapping';

export interface OSSSubsectionConfig {
  name: string;
  boxCode: string;
}

export interface OSSCountryConfig {
  name: string;
  code: string;
  sectionIndex: number;
  rows: OSSSubsectionConfig[];
}

export const OSS_COUNTRY_TABLES: OSSCountryConfig[] = [
  {
    name: 'Malta',
    code: 'mt',
    sectionIndex: 0,
    rows: [
      { name: 'Goods @ 18%', boxCode: 'MT1' },
      { name: 'Goods @ 7%', boxCode: 'MT2' },
      { name: 'Goods @ 5%', boxCode: 'MT3' },
      { name: 'Services @ 18%', boxCode: 'MT4' },
      { name: 'Services @ 12%', boxCode: 'MT5' },
      { name: 'Services @ 7%', boxCode: 'MT6' },
      { name: 'Services @ 5%', boxCode: 'MT7' },
    ],
  },
  {
    name: 'Austria',
    code: 'au',
    sectionIndex: 1,
    rows: [
      { name: 'Goods @ 20%', boxCode: 'AU1' },
      { name: 'Goods @ 10%', boxCode: 'AU2' },
      { name: 'Goods @ 13%', boxCode: 'AU3' },
      { name: 'Services @ 10%', boxCode: 'AU4' },
      { name: 'Services @ 20%', boxCode: 'AU5' },
      { name: 'Services @ 13%', boxCode: 'AU6' },
    ],
  },
  {
    name: 'Belgium',
    code: 'be',
    sectionIndex: 2,
    rows: [
      { name: 'Goods @ 21%', boxCode: 'BE1' },
      { name: 'Goods @ 12%', boxCode: 'BE2' },
      { name: 'Goods @ 6%', boxCode: 'BE3' },
      { name: 'Services @ 21%', boxCode: 'BE4' },
      { name: 'Services @ 12%', boxCode: 'BE5' },
      { name: 'Services @ 6%', boxCode: 'BE6' },
    ],
  },
  {
    name: 'Bulgaria',
    code: 'bg',
    sectionIndex: 3,
    rows: [
      { name: 'Goods @ 20%', boxCode: 'BG1' },
      { name: 'Goods @ 9%', boxCode: 'BG2' },
      { name: 'Services @ 20%', boxCode: 'BG3' },
      { name: 'Services @ 9%', boxCode: 'BG4' },
    ],
  },
  {
    name: 'Croatia',
    code: 'hr',
    sectionIndex: 4,
    rows: [
      { name: 'Goods @ 25%', boxCode: 'HR1' },
      { name: 'Goods @ 13%', boxCode: 'HR2' },
      { name: 'Goods @ 5%', boxCode: 'HR3' },
      { name: 'Services @ 25%', boxCode: 'HR4' },
      { name: 'Services @ 13%', boxCode: 'HR5' },
      { name: 'Services @ 5%', boxCode: 'HR6' },
    ],
  },
  {
    name: 'Cyprus',
    code: 'cy',
    sectionIndex: 5,
    rows: [
      { name: 'Goods @ 19%', boxCode: 'CY1' },
      { name: 'Goods @ 5%', boxCode: 'CY2' },
      { name: 'Goods @ 9%', boxCode: 'CY3' },
      { name: 'Services @ 19%', boxCode: 'CY4' },
      { name: 'Services @ 5%', boxCode: 'CY5' },
      { name: 'Services @ 9%', boxCode: 'CY6' },
    ],
  },
  {
    name: 'Czech Republic',
    code: 'cz',
    sectionIndex: 6,
    rows: [
      { name: 'Goods @ 21%', boxCode: 'CZ1' },
      { name: 'Goods @ 12%', boxCode: 'CZ2' },
      { name: 'Services @ 12%', boxCode: 'CZ3' },
      { name: 'Services @ 21%', boxCode: 'CZ4' },
    ],
  },
  {
    name: 'Denmark',
    code: 'dk',
    sectionIndex: 7,
    rows: [
      { name: 'Goods @ 25%', boxCode: 'DK1' },
      { name: 'Services @ 25%', boxCode: 'DK2' },
    ],
  },
  {
    name: 'Estonia',
    code: 'ee',
    sectionIndex: 8,
    rows: [
      { name: 'Goods @ 22%', boxCode: 'EE1' },
      { name: 'Goods @ 9%', boxCode: 'EE2' },
      { name: 'Services @ 22%', boxCode: 'EE3' },
      { name: 'Services @ 9%', boxCode: 'EE4' },
    ],
  },
  {
    name: 'Finland',
    code: 'fi',
    sectionIndex: 9,
    rows: [
      { name: 'Goods @ 25.5%', boxCode: 'FI1' },
      { name: 'Goods @ 14%', boxCode: 'FI2' },
      { name: 'Goods @ 10%', boxCode: 'FI3' },
      { name: 'Services @ 25.5%', boxCode: 'FI4' },
      { name: 'Services @ 14%', boxCode: 'FI5' },
      { name: 'Services @ 10%', boxCode: 'FI6' },
    ],
  },
  {
    name: 'France',
    code: 'fr',
    sectionIndex: 10,
    rows: [
      { name: 'Goods @ 20%', boxCode: 'FR1' },
      { name: 'Goods @ 10%', boxCode: 'FR2' },
      { name: 'Goods @ 5.5%', boxCode: 'FR3' },
      { name: 'Services @ 20%', boxCode: 'FR4' },
      { name: 'Services @ 10%', boxCode: 'FR5' },
      { name: 'Services @ 5.5%', boxCode: 'FR6' },
    ],
  },
  {
    name: 'Germany',
    code: 'de',
    sectionIndex: 11,
    rows: [
      { name: 'Goods @ 19%', boxCode: 'DE1' },
      { name: 'Goods @ 7%', boxCode: 'DE2' },
      { name: 'Services @ 19%', boxCode: 'DE3' },
      { name: 'Services @ 7%', boxCode: 'DE4' },
    ],
  },
  {
    name: 'Greece',
    code: 'el',
    sectionIndex: 12,
    rows: [
      { name: 'Goods @ 24%', boxCode: 'EL1' },
      { name: 'Goods @ 13%', boxCode: 'EL2' },
      { name: 'Goods @ 6%', boxCode: 'EL3' },
      { name: 'Services @ 24%', boxCode: 'EL4' },
      { name: 'Services @ 13%', boxCode: 'EL5' },
      { name: 'Services @ 6%', boxCode: 'EL6' },
    ],
  },
  {
    name: 'Hungary',
    code: 'hu',
    sectionIndex: 13,
    rows: [
      { name: 'Goods @ 27%', boxCode: 'HU1' },
      { name: 'Goods @ 18%', boxCode: 'HU2' },
      { name: 'Goods @ 5%', boxCode: 'HU3' },
      { name: 'Services @ 27%', boxCode: 'HU4' },
      { name: 'Services @ 18%', boxCode: 'HU5' },
      { name: 'Services @ 5%', boxCode: 'HU6' },
    ],
  },
  {
    name: 'Ireland',
    code: 'ie',
    sectionIndex: 14,
    rows: [
      { name: 'Goods @ 23%', boxCode: 'IE1' },
      { name: 'Goods @ 13.5%', boxCode: 'IE2' },
      { name: 'Goods @ 9%', boxCode: 'IE3' },
      { name: 'Goods @ 4.8%', boxCode: 'IE4' },
      { name: 'Services @ 23%', boxCode: 'IE5' },
      { name: 'Services @ 13.5%', boxCode: 'IE6' },
      { name: 'Services @ 9%', boxCode: 'IE7' },
      { name: 'Services @ 4.8%', boxCode: 'IE8' },
    ],
  },
  {
    name: 'Italy',
    code: 'it',
    sectionIndex: 15,
    rows: [
      { name: 'Goods @ 22%', boxCode: 'IT1' },
      { name: 'Goods @ 5%', boxCode: 'IT2' },
      { name: 'Goods @ 4%', boxCode: 'IT3' },
      { name: 'Goods @ 10%', boxCode: 'IT4' },
      { name: 'Services @ 22%', boxCode: 'IT5' },
      { name: 'Services @ 5%', boxCode: 'IT6' },
      { name: 'Services @ 4%', boxCode: 'IT7' },
      { name: 'Services @ 10%', boxCode: 'IT8' },
    ],
  },
  {
    name: 'Latvia',
    code: 'lv',
    sectionIndex: 16,
    rows: [
      { name: 'Goods @ 21%', boxCode: 'LV1' },
      { name: 'Goods @ 5%', boxCode: 'LV2' },
      { name: 'Goods @ 12%', boxCode: 'LV3' },
      { name: 'Services @ 21%', boxCode: 'LV4' },
      { name: 'Services @ 5%', boxCode: 'LV5' },
      { name: 'Services @ 12%', boxCode: 'LV6' },
    ],
  },
  {
    name: 'Lithuania',
    code: 'lt',
    sectionIndex: 17,
    rows: [
      { name: 'Goods @ 21%', boxCode: 'LT1' },
      { name: 'Goods @ 9%', boxCode: 'LT2' },
      { name: 'Goods @ 5%', boxCode: 'LT3' },
      { name: 'Services @ 21%', boxCode: 'LT4' },
      { name: 'Services @ 9%', boxCode: 'LT5' },
      { name: 'Services @ 5%', boxCode: 'LT6' },
    ],
  },
  {
    name: 'Luxembourg',
    code: 'lu',
    sectionIndex: 18,
    rows: [
      { name: 'Goods @ 17%', boxCode: 'LU1' },
      { name: 'Goods @ 16%', boxCode: 'LU2' },
      { name: 'Goods @ 14%', boxCode: 'LU3' },
      { name: 'Goods @ 13%', boxCode: 'LU4' },
      { name: 'Goods @ 8%', boxCode: 'LU5' },
      { name: 'Goods @ 7%', boxCode: 'LU6' },
      { name: 'Goods @ 3%', boxCode: 'LU7' },
      { name: 'Services @ 17%', boxCode: 'LU8' },
      { name: 'Services @ 16%', boxCode: 'LU9' },
      { name: 'Services @ 14%', boxCode: 'LU10' },
      { name: 'Services @ 13%', boxCode: 'LU11' },
      { name: 'Services @ 8%', boxCode: 'LU12' },
      { name: 'Services @ 7%', boxCode: 'LU13' },
      { name: 'Services @ 3%', boxCode: 'LU14' },
    ],
  },
  {
    name: 'Netherlands',
    code: 'nl',
    sectionIndex: 19,
    rows: [
      { name: 'Goods @ 21%', boxCode: 'NL1' },
      { name: 'Goods @ 9%', boxCode: 'NL2' },
      { name: 'Services @ 21%', boxCode: 'NL3' },
      { name: 'Services @ 9%', boxCode: 'NL4' },
    ],
  },
  {
    name: 'Poland',
    code: 'pl',
    sectionIndex: 20,
    rows: [
      { name: 'Goods @ 23%', boxCode: 'PL1' },
      { name: 'Goods @ 5%', boxCode: 'PL2' },
      { name: 'Goods @ 8%', boxCode: 'PL3' },
      { name: 'Services @ 23%', boxCode: 'PL4' },
      { name: 'Services @ 5%', boxCode: 'PL5' },
      { name: 'Services @ 8%', boxCode: 'PL6' },
    ],
  },
  {
    name: 'Portugal',
    code: 'pt',
    sectionIndex: 21,
    rows: [
      { name: 'Goods @ 23%', boxCode: 'PT1' },
      { name: 'Goods @ 6%', boxCode: 'PT2' },
      { name: 'Goods @ 13%', boxCode: 'PT3' },
      { name: 'Services @ 23%', boxCode: 'PT4' },
      { name: 'Services @ 6%', boxCode: 'PT5' },
      { name: 'Services @ 13%', boxCode: 'PT6' },
    ],
  },
  {
    name: 'Romania',
    code: 'ro',
    sectionIndex: 22,
    rows: [
      { name: 'Goods @ 19%', boxCode: 'RO1' },
      { name: 'Goods @ 5%', boxCode: 'RO2' },
      { name: 'Goods @ 9%', boxCode: 'RO3' },
      { name: 'Services @ 19%', boxCode: 'RO4' },
      { name: 'Services @ 5%', boxCode: 'RO5' },
      { name: 'Services @ 9%', boxCode: 'RO6' },
    ],
  },
  {
    name: 'Slovakia',
    code: 'sk',
    sectionIndex: 23,
    rows: [
      { name: 'Goods @ 23%', boxCode: 'SK1' },
      { name: 'Goods @ 19%', boxCode: 'SK2' },
      { name: 'Goods @ 10%', boxCode: 'SK3' },
      { name: 'Goods @ 5%', boxCode: 'SK4' },
      { name: 'Services @ 23%', boxCode: 'SK5' },
      { name: 'Services @ 19%', boxCode: 'SK6' },
      { name: 'Services @ 10%', boxCode: 'SK7' },
      { name: 'Services @ 5%', boxCode: 'SK8' },
    ],
  },
  {
    name: 'Slovenia',
    code: 'sl',
    sectionIndex: 24,
    rows: [
      { name: 'Goods @ 22%', boxCode: 'SL1' },
      { name: 'Goods @ 5%', boxCode: 'SL2' },
      { name: 'Goods @ 9.5%', boxCode: 'SL3' },
      { name: 'Services @ 22%', boxCode: 'SL4' },
      { name: 'Services @ 5%', boxCode: 'SL5' },
      { name: 'Services @ 9.5%', boxCode: 'SL6' },
    ],
  },
  {
    name: 'Sweden',
    code: 'se',
    sectionIndex: 25,
    rows: [
      { name: 'Goods @ 25%', boxCode: 'SE1' },
      { name: 'Goods @ 12%', boxCode: 'SE2' },
      { name: 'Goods @ 6%', boxCode: 'SE3' },
      { name: 'Services @ 25%', boxCode: 'SE4' },
      { name: 'Services @ 12%', boxCode: 'SE5' },
      { name: 'Services @ 6%', boxCode: 'SE6' },
    ],
  },
  {
    name: 'Spain',
    code: 'es',
    sectionIndex: 26,
    rows: [
      { name: 'Goods @ 21%', boxCode: 'ES1' },
      { name: 'Goods @ 4%', boxCode: 'ES2' },
      { name: 'Goods @ 10%', boxCode: 'ES3' },
      { name: 'Goods @ 7.5%', boxCode: 'ES4' },
      { name: 'Goods @ 2%', boxCode: 'ES5' },
      { name: 'Goods @ 0%', boxCode: 'ES6' },
      { name: 'Services @ 21%', boxCode: 'ES7' },
      { name: 'Services @ 4%', boxCode: 'ES8' },
      { name: 'Services @ 10%', boxCode: 'ES9' },
      { name: 'Services @ 7.5%', boxCode: 'ES10' },
      { name: 'Services @ 2%', boxCode: 'ES11' },
      { name: 'Services @ 0%', boxCode: 'ES12' },
    ],
  },
];

const normalizeSectionName = (name: string) => name.trim().toLowerCase();

const tablesByName = () =>
  new Map(
    OSS_COUNTRY_TABLES.map((table) => [
      normalizeSectionName(table.name),
      table,
    ])
  );

const orderCountryTables = (
  tables: OSSCountryConfig[],
  reportSectionNames?: string[],
  sections?: Section[]
): OSSCountryConfig[] => {
  if (reportSectionNames?.length) {
    const byName = new Map(
      tables.map((table) => [normalizeSectionName(table.name), table])
    );

    const orderedFromReport = reportSectionNames
      .map((name, index) => {
        const table = byName.get(normalizeSectionName(name));
        return table ? { ...table, sectionIndex: index } : null;
      })
      .filter((table): table is OSSCountryConfig => table !== null);

    if (orderedFromReport.length > 0) {
      return orderedFromReport;
    }
  }

  if (sections?.length) {
    const byName = new Map(
      tables.map((table) => [normalizeSectionName(table.name), table])
    );

    const orderedFromSections = [...sections]
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map((section, index) => {
        const table = byName.get(normalizeSectionName(section.name));
        return table ? { ...table, sectionIndex: index } : null;
      })
      .filter((table): table is OSSCountryConfig => table !== null);

    if (orderedFromSections.length > 0) {
      return orderedFromSections;
    }
  }

  return tables.map((table, index) => ({
    ...table,
    sectionIndex: index,
  }));
};

const filterCountriesByMappedCodes = (
  mappedCodes: Iterable<string>
): OSSCountryConfig[] =>
  OSS_COUNTRY_TABLES.filter((country) =>
    ossCountryHasMappedSubsection(
      country.rows.map((row) => row.boxCode),
      mappedCodes
    )
  );

/**
 * OSS report tables visible for this return: countries with mapped subsections,
 * ordered like mapping sections and re-indexed for `section10{n}-name` DOM ids.
 */
export const resolveVisibleOssCountryTables = (
  jsonMapping: MappingTaxRate[] | undefined,
  sections: Section[] | undefined,
  returnTypeId: string | undefined,
  reportSectionNames?: string[],
  reportSubsectionCodes?: string[]
): OSSCountryConfig[] => {
  const byName = tablesByName();
  const mappedCodes = getMappedSubsectionCodesFromJsonMapping(jsonMapping);

  if (mappedCodes.size > 0) {
    const fromMappedCodes = filterCountriesByMappedCodes(mappedCodes);
    if (fromMappedCodes.length > 0) {
      const sectionOrder =
        isOssReturnType(returnTypeId) && sections?.length
          ? sections
              .filter((section) =>
                deriveOssCountryIdsFromJsonMapping(
                  jsonMapping,
                  sections,
                  returnTypeId
                ).includes(section.id)
              )
              .sort((a, b) => a.sortOrder - b.sortOrder)
          : undefined;

      return orderCountryTables(
        fromMappedCodes,
        reportSectionNames,
        sectionOrder
      );
    }
  }

  if (
    isOssReturnType(returnTypeId) &&
    sections?.length &&
    jsonMapping?.length
  ) {
    const ossCountryIds = deriveOssCountryIdsFromJsonMapping(
      jsonMapping,
      sections,
      returnTypeId
    );

    const tablesFromMapping = sections
      .filter((section) => ossCountryIds.includes(section.id))
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map((section, index) => {
        const table = byName.get(normalizeSectionName(section.name));
        return table ? { ...table, sectionIndex: index } : null;
      })
      .filter((table): table is OSSCountryConfig => table !== null);

    if (tablesFromMapping.length > 0) {
      return tablesFromMapping;
    }
  }

  if (reportSectionNames?.length) {
    const fromReportSections = reportSectionNames
      .map((name, index) => {
        const table = byName.get(normalizeSectionName(name));
        return table ? { ...table, sectionIndex: index } : null;
      })
      .filter((table): table is OSSCountryConfig => table !== null);

    if (fromReportSections.length > 0) {
      return fromReportSections;
    }
  }

  if (reportSubsectionCodes?.length) {
    const fromReportCodes = filterCountriesByMappedCodes(reportSubsectionCodes);
    if (fromReportCodes.length > 0) {
      return orderCountryTables(
        fromReportCodes,
        reportSectionNames,
        sections
      );
    }
  }

  return [];
};
